import * as newsApi from '../../api/news'

// eslint-disable-next-line no-unused-vars
async function fetchNews({ dispatch }, { page, limit }) {
  const response = await newsApi.fetchNews({ page, limit })
  return response
}

const newsStore = {
  actions: {
    fetchNews
  }
}

export default newsStore
